"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessQuickCategoryWidgetDataSchema = exports.BusinessQuickCategoryGroupSchema = exports.BusinessQuickCategoryItemSchema = exports.BusinessQuickCategoryBadgeSchema = void 0;
var zod_1 = require("zod");
exports.BusinessQuickCategoryBadgeSchema = zod_1.z.object({
    title: zod_1.z.string().optional(),
    animationInfo: zod_1.z
        .object({
        texts: zod_1.z.array(zod_1.z.string()),
        rollingInterval: zod_1.z.number(),
    })
        .optional(),
});
exports.BusinessQuickCategoryItemSchema = zod_1.z.object({
    title: zod_1.z.string(),
    type: zod_1.z.string(),
    badge: exports.BusinessQuickCategoryBadgeSchema.optional(),
    image: zod_1.z.object({ url: zod_1.z.string() }),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    serverLogMeta: zod_1.z.object({
        widgetTitle: zod_1.z.string(),
        widgetTargetTitle: zod_1.z.string(),
        quickCategoryBoardId: zod_1.z.string(),
        deepLinkUri: zod_1.z.string(),
        object: zod_1.z.string(),
        position: zod_1.z.number(),
        quickCategoryComponentTitle: zod_1.z.string(),
        quickCategoryComponentId: zod_1.z.string(),
        widgetPosition: zod_1.z.number(),
    }),
});
exports.BusinessQuickCategoryGroupSchema = zod_1.z.object({
    max: zod_1.z.number(),
    count: zod_1.z.number(),
    type: zod_1.z.string(),
    items: zod_1.z.array(exports.BusinessQuickCategoryItemSchema),
});
exports.BusinessQuickCategoryWidgetDataSchema = zod_1.z.object({
    items: zod_1.z.array(exports.BusinessQuickCategoryGroupSchema),
});
